import client from '/src/services/client.js';

export default {
    getConversations : (data) => client.get('conversations/upgoing', data),
    getConversation : ({ id }) => client.get(`conversation/upgoing/${id}`, {}),
    deleteConversation : (id,data ) => client.delete(`conversation/upgoing/${id}`,data),

    deleteAllConversation : ({data}) => client.delete(`conversations/upgoing`,data),
    deleteMultiplesConversation : (data) => client.post(`conversations/upgoing/multiples`, data),

    updateConversation : ({ id }) => client.put(`conversation/upgoin/${id}`, {}),
    getConversationMarkers: (data) => client.get(`conversation/markers`, data),
    getMarkersOfConversation: ({ id }) => client.get(`conversation/${id}/markers`, {}),
    deleteMarkerFromConversation: ({ conversationId, markerId }) => client.delete(`conversation/${conversationId}/marker/${markerId}`, {}),
    setMarkerToConversation: ({ conversationId, markerId }) => client.post(`conversation/${conversationId}/marker/${markerId}`, {}),
}
